import React from 'react'

class Error404 extends React.Component {
  render () {

      let style = {
          position: 'absolute',
          top:'50%',
          left:'50%',
          transform:'translate(-50%,-50%)'
      }

      let containerStyle={
        position:'relative',
        height:'100vh',
        width:'100vw'
      }

      return (
          <div style={containerStyle}>
            <div style={style}><h3>Error 404 - Page not found</h3></div>
          </div>
      )
  }
}

export default Error404;



// WEBPACK FOOTER //
// ./src/modules/pages/Error404.js